import OSS from 'ali-oss'

const region = "oss-cn-chengdu"
const accessKeyId = "LTAI4G72mbJZciambswruM5f"
const accessKeySecret = "ylzZvmHa0aPw3Mv1aqLNaGo1FwGp1g"
const bucket = "cdzx"
import { Message } from 'element-ui';
let client = new OSS({
  region: region,
  accessKeyId: accessKeyId,
  accessKeySecret: accessKeySecret,
  bucket: bucket
});
const CooOss = function (file) {
  
  if (this instanceof CooOss) {
    let objectKey = file.lastModified + '_' + file.name;
    console.log(file.size/1024)
    console.log(objectKey, file)
    return new Promise((resolve, reject) => {
      client.multipartUpload(objectKey, file).then(result => {
        console.log(result,111)
        resolve({
          code: 2,
          objectKey: objectKey,
          url: this.getOssFileUrl(objectKey),
          msg: "ok"
        });
      }).catch(err => {
        console.log(err,333)
        console.error('上传出错了');
        Message.error('上传出错了');
        reject({ code: -1, url: "", objectKey: "", msg: "上传出错了" });
      });
    })
  }
  else {
    return new CooOss(file);
  }
};

CooOss.prototype.getOssFileUrl = obecjtKey => {
  if (!obecjtKey) return new Error("object key 必须传");
  return "https://" + bucket + "." + region + ".aliyuncs.com/" + obecjtKey;
}
export default {
  install(Vue) {
    Vue.prototype.Oss = {
      uploadFile: CooOss
    };
  }
};


// WEBPACK FOOTER //
// ./src/utils/alioss.js